import { useState } from "react";
import { api } from "../App";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";

export default function StaleUpdateModal({ entityType, entityId, entityTitle, onSave }) {
  const [text, setText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (text.trim().length < 20) { toast.error("Please write at least 20 characters"); return; }
    setSubmitting(true);
    try {
      const endpoint = entityType === "task"
        ? `/tasks/${entityId}/comments`
        : `/bizdev/briefs/${entityId}/comments`;
      await api.post(endpoint, { text: text.trim(), mentions: [] });
      toast.success("Update posted");
      onSave();
    } catch (e) { toast.error("Failed to post update"); }
    finally { setSubmitting(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,.6)", backdropFilter: "blur(4px)" }}>
      <div style={{ background: "var(--s1)", border: "1px solid var(--bdr)", borderRadius: 16, padding: 28, width: "min(440px, 90vw)", boxShadow: "0 20px 60px rgba(0,0,0,.3)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(239,68,68,.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <AlertTriangle size={18} style={{ color: "#EF4444" }} />
          </div>
          <div>
            <h3 style={{ fontSize: 15, fontWeight: 700, color: "var(--t1)", fontFamily: "var(--font-orb)" }}>Update Required</h3>
            <p style={{ fontSize: 11, color: "var(--t3)" }}>This {entityType} hasn't been updated in a while</p>
          </div>
        </div>

        {entityTitle && <p style={{ fontSize: 13, color: "var(--t2)", marginBottom: 12, fontWeight: 500 }}>{entityTitle}</p>}

        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder={`What's the status of this ${entityType}? (min 20 characters)`}
          rows={4}
          style={{
            width: "100%", padding: 12, borderRadius: 10, border: "1px solid var(--bdr)",
            background: "var(--s2)", color: "var(--t1)", fontSize: 13, resize: "vertical",
            outline: "none"
          }}
        />

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 12 }}>
          <span style={{ fontSize: 11, color: text.trim().length >= 20 ? "var(--g)" : "var(--t3)", fontFamily: "var(--font-mono)" }}>
            {text.trim().length}/20 min
          </span>
          <button
            onClick={handleSubmit}
            disabled={submitting || text.trim().length < 20}
            style={{
              padding: "10px 24px", borderRadius: 10, border: "none", cursor: "pointer",
              background: text.trim().length >= 20 ? "var(--r)" : "var(--s3)",
              color: text.trim().length >= 20 ? "#fff" : "var(--t3)",
              fontSize: 13, fontWeight: 700, transition: "all .15s"
            }}
          >
            {submitting ? "Posting..." : "Post Update"}
          </button>
        </div>
      </div>
    </div>
  );
}
